import { useEffect, useState } from 'react'
import { Eye } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { PREVIEW_BLOCKED_EVENT } from '@/lib/previewMode'

/** Mounted once in PortalLayout. */
export function PreviewBlockedDialog() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const show = () => setOpen(true)
    window.addEventListener(PREVIEW_BLOCKED_EVENT, show)
    return () => window.removeEventListener(PREVIEW_BLOCKED_EVENT, show)
  }, [])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50" onClick={() => setOpen(false)}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="preview-blocked-title"
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 space-y-4"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 text-gray-900">
          <Eye size={20} className="text-amber-500" />
          <h2 id="preview-blocked-title" className="text-lg font-semibold">This is a read-only preview</h2>
        </div>
        <p className="text-sm text-gray-600">
          You're viewing the portal as your client sees it, so changes can't be made from here. Your client
          can do this when they sign in to their own portal.
        </p>
        <Button className="w-full" onClick={() => setOpen(false)} autoFocus>Got it</Button>
      </div>
    </div>
  )
}
